// Mock data for Local Business Heroes website

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    business: "",
    location: "Manchester",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "Since using Local Business Heroes, we've increased our bookings by 40% and I've got my evenings back! The automated follow-up messages are brilliant - clients love the personal touch and I don't have to remember to chase up missed appointments anymore.",
    results: "40% more bookings in 3 months"
  },
  {
    id: 2,
    name: "James Thompson",
    business: "",
    location: "Birmingham",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "The lead capture tools are game-changers. We're now converting 60% more website visitors into members, and the review builder helped us go from 12 Google reviews to over 150 in just 4 months. Absolutely brilliant system!",
    results: "60% higher conversion rate"
  },
  {
    id: 3,
    name: "Emma Clarke",
    business: "",
    location: "Leeds",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "I was drowning in enquiries and losing potential customers because I couldn't follow up quickly enough. Now everything's automated - from the initial contact to booking consultations. My revenue has doubled and I actually have time for my family again.",
    results: "Revenue doubled in 6 months"
  },
  {
    id: 4,
    name: "David Patel",
    business: "",
    location: "London",
    image: "https://images.unsplash.com/photo-1566492031773-4f4e44671857?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "Before Local Business Heroes, I was losing at least 3-4 jobs a week because I couldn't respond to enquiries fast enough. Now the system captures leads 24/7 and follows up automatically. My conversion rate has gone through the roof and I'm fully booked two weeks in advance.",
    results: "Fully booked in 2 months"
  },
  {
    id: 5,
    name: "Rachel Green",
    business: "",
    location: "Bristol",
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "As a one-person accounting practice, I needed a way to look bigger than I am. The automated emails and booking system make me look like a proper firm. I've landed three corporate clients in the last quarter who said my professionalism stood out.",
    results: "3 corporate clients signed"
  },
  {
    id: 6,
    name: "Michael O'Brien",
    business: "",
    location: "Glasgow",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "The SMS appointment reminders alone have saved me thousands in wasted time. No-shows dropped from 20% to under 5%. Plus, the review automation got us to 4.9 stars on Google which has brought in loads more work. Best investment I've made in the business.",
    results: "No-shows down 75%"
  },
  {
    id: 7,
    name: "Lisa Henderson",
    business: "",
    location: "Edinburgh",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "I'm not tech-savvy at all, but the setup was dead simple. Within a week I had automated booking, follow-ups, and even social media posts going out. My daughter doesn't believe I'm doing it all myself! Revenue is up 55% and I'm actually taking proper holidays now.",
    results: "55% revenue increase"
  },
  {
    id: 8,
    name: "Tom Bradley",
    business: "",
    location: "Liverpool",
    image: "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "We were using three different systems before - one for CRM, one for email, one for scheduling. Everything's now in one place and costs less than what we were paying before. Staff adoption was instant because it's so intuitive. Game changer for our efficiency.",
    results: "Consolidated 3 tools into 1"
  },
  {
    id: 9,
    name: "Priya Sharma",
    business: "",
    location: "Leicester",
    image: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "Patient no-shows were costing us over £2,000 a month. The automated reminder system has been incredible - we've gone from 15% no-shows to just 3%. The ROI calculator shows we've saved over £20,000 in the first year. Absolutely worth every penny.",
    results: "£20k saved in 12 months"
  },
  {
    id: 10,
    name: "Andrew Wilson",
    business: "",
    location: "Newcastle",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "I run a small operation - just me and two lads. This system makes us look like a proper company. The automated quotes, booking confirmations, and follow-ups are spot on. Picked up 40 new regular customers in three months without spending a penny on advertising.",
    results: "40 new regular customers"
  },
  {
    id: 11,
    name: "Sophie Taylor",
    business: "",
    location: "Oxford",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "Wedding season used to be chaos. Now all my consultations are booked online, deposits are automated, and clients get regular updates about their cake. I've gone from doing 2 weddings a month to 6, and my stress levels have actually gone down. Couldn't run the business without it now.",
    results: "3x wedding bookings"
  },
  {
    id: 12,
    name: "Robert Hughes",
    business: "",
    location: "Cardiff",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "Been in roofing for 30 years and always done things old school. My son convinced me to try this and I wish I'd done it years ago. The follow-up system is brilliant - we're closing 70% of quotes now versus 40% before. Even taught this old dog new tricks with the social media scheduler!",
    results: "70% quote conversion rate"
  },
  {
    id: 13,
    name: "Natasha Williams",
    business: "",
    location: "Brighton",
    image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "The patient journey from first enquiry to becoming a regular is now completely automated. New patients get a welcome series, current patients get helpful tips, and we automatically request reviews after treatment. Our Google rating went from 4.2 to 4.8 stars in six months.",
    results: "4.8 star Google rating"
  },
  {
    id: 14,
    name: "Kevin McDonald",
    business: "",
    location: "Aberdeen",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "In pest control, speed is everything. People want someone NOW. The instant text response to website enquiries has been a game changer - even if I'm on a job, leads get an immediate reply. My booking rate has gone from 50% to 85%. Pays for itself ten times over.",
    results: "85% booking rate"
  },
  {
    id: 15,
    name: "Amanda Foster",
    business: "",
    location: "Southampton",
    image: "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "I was spending 2 hours every evening replying to Facebook messages and emails. Now it's all handled automatically with the chat widget and email sequences. I've got 30 more hours a month to actually train dogs! Plus the waiting list feature makes my classes look exclusive.",
    results: "30 hours saved per month"
  },
  {
    id: 16,
    name: "Gary Thompson",
    business: "",
    location: "Nottingham",
    image: "https://images.unsplash.com/photo-1463453091185-61582044d556?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "MOT season is mental busy. The automated reminders mean customers book in advance instead of ringing up the day before. We've gone from 60% repeat customers to 89%. The missed call follow-up feature alone has brought in thousands of pounds worth of extra business.",
    results: "89% customer retention"
  },
  {
    id: 17,
    name: "Jennifer Lee",
    business: "",
    location: "Cambridge",
    image: "https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "Managing 12 cleaners and their schedules was a nightmare. Now clients can book online, cleaners get their routes automatically, and I can see everything from my phone. We've taken on 40% more clients without hiring extra admin staff. It's like having a full-time office manager for a fraction of the cost.",
    results: "40% more clients, no extra admin"
  },
  {
    id: 18,
    name: "Stuart Robertson",
    business: "",
    location: "Dundee",
    image: "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "Compliance in financial services is tough, but this system keeps perfect records of all client communications. The automated meeting reminders and follow-ups keep everything professional. I've doubled my client base in 18 months whilst actually working fewer hours. Worth every single penny.",
    results: "Client base doubled"
  },
  {
    id: 19,
    name: "Claire Martinez",
    business: "",
    location: "Sheffield",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "Being mobile meant I was always missing calls. The system catches every enquiry, books appointments, takes payments, and even handles rescheduling. My diary is consistently full and I'm not glued to my phone anymore. Customers love the professionalism too.",
    results: "Diary consistently full"
  },
  {
    id: 20,
    name: "Peter Collins",
    business: "",
    location: "Bournemouth",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "Seasonal business is hard to manage. The CRM helps me plan ahead, send quotes in winter for spring work, and keep in touch with customers year-round. Regular customers went from 30% to 75% of my business. I'm not scrambling for work every spring anymore.",
    results: "75% repeat business"
  },
  {
    id: 21,
    name: "Marcus Johnson",
    business: "",
    location: "Portsmouth",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=120&h=120&fit=crop&crop=face",
    rating: 5,
    text: "Running a gym means constant juggling of memberships, class bookings, and personal training sessions. This platform handles it all seamlessly. Member retention is up 45% because we never miss a birthday or renewal reminder. The automated workout tips keep members engaged between visits. Best decision I've made for the business.",
    results: "45% better member retention"
  }
];

export const features = [
  {
    id: 1,
    title: "Lead Engine",
    icon: "Target",
    description: "Capture more leads with landing pages, forms, and widgets that actually convert visitors into customers.",
    benefits: ["High-converting landing pages", "Smart lead capture forms", "Website chat widgets", "Lead scoring & tracking"]
  },
  {
    id: 2,
    title: "Hero CRM",
    icon: "Users",
    description: "Manage every customer from first contact to loyal advocate with our intuitive pipeline system.",
    benefits: ["Visual sales pipeline", "Contact management", "Deal tracking", "Customer history"]
  },
  {
    id: 3,
    title: "AI Follow-Up",
    icon: "MessageSquare",
    description: "Never lose a lead again with intelligent SMS and email automation that feels personal.",
    benefits: ["Smart email sequences", "SMS automation", "Personalised messages", "Multi-channel campaigns"]
  },
  {
    id: 4,
    title: "Review Builder",
    icon: "Star",
    description: "Get more 5-star reviews automatically and protect your reputation online.",
    benefits: ["Automated review requests", "Reputation monitoring", "Review response templates", "Google My Business sync"]
  },
  {
    id: 5,
    title: "Scheduler",
    icon: "Calendar",
    description: "Let customers book appointments 24/7 with intelligent scheduling that prevents double-bookings.",
    benefits: ["Online booking system", "Calendar sync", "Automated reminders", "No-show reduction"]
  },
  {
    id: 6,
    title: "Social Engine",
    icon: "Share2",
    description: "Schedule and manage all your social media posts from one dashboard.",
    benefits: ["Multi-platform posting", "Content calendar", "Post scheduling", "Engagement tracking"]
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "HERO STARTER",
    icon: "💼",
    price: 297,
    popular: false,
    description: "Perfect for getting started with automation",
    features: [
      "Up to 1,000 contacts",
      "Lead capture pages",
      "Basic CRM pipeline",
      "Email & SMS automation",
      "Online scheduler",
      "Review management",
      "Basic reporting",
      "Email support"
    ],
    outcomes: ["2x more leads", "50% time saved", "Better follow-up"]
  },
  {
    id: 2,
    name: "HERO GROWTH",
    icon: "🚀",
    price: 497,
    popular: true,
    description: "Most popular - Everything you need to scale",
    features: [
      "Up to 10,000 contacts",
      "Unlimited landing pages",
      "Advanced CRM + pipeline",
      "AI-powered automation",
      "Advanced scheduler",
      "Reputation management",
      "Social media scheduler",
      "Advanced analytics",
      "Phone + email support",
      "Setup assistance"
    ],
    outcomes: ["5x more leads", "70% time saved", "Automated growth"]
  },
  {
    id: 3,
    name: "HERO DOMINATION",
    icon: "🏆",
    price: 997,
    popular: false,
    description: "For serious growth and market domination",
    features: [
      "Unlimited contacts",
      "White-label branding",
      "Advanced AI features",
      "Multi-location support",
      "Custom integrations",
      "Priority support",
      "Dedicated account manager",
      "Custom training",
      "All future features"
    ],
    outcomes: ["10x growth potential", "Complete automation", "Market leadership"]
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "5 Ways to Automate Follow-Up Without Lifting a Finger",
    excerpt: "Discover how successful local businesses are using automation to nurture leads and convert more customers while they sleep.",
    category: "Automation",
    readTime: "4 min read",
    date: "2024-03-15",
    image: "https://images.pexels.com/photos/171198/pexels-photo-171198.jpeg?w=400&h=240&fit=crop&crop=center",
    slug: "automate-follow-up-local-business"
  },
  {
    id: 2,
    title: "The Local Business Owner's Guide to Getting More Google Reviews",
    excerpt: "Learn the exact system that helped our clients increase their Google reviews by 300% in just 90 days.",
    category: "Reviews",
    readTime: "6 min read",
    date: "2024-03-12",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=240&fit=crop&crop=center",
    slug: "get-more-google-reviews"
  },
  {
    id: 3,
    title: "Why Your Website Isn't Converting Visitors (And How to Fix It)",
    excerpt: "The 7 critical elements every local business website needs to turn browsers into buyers.",
    category: "Lead Generation",
    readTime: "5 min read",
    date: "2024-03-10",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=240&fit=crop&crop=center",
    slug: "website-conversion-tips"
  },
  {
    id: 4,
    title: "SMS Marketing for Local Businesses: Complete Beginner's Guide",
    excerpt: "How to use text messaging to increase bookings, reduce no-shows, and build stronger customer relationships.",
    category: "SMS Marketing",
    readTime: "7 min read",
    date: "2024-03-08",
    image: "https://images.unsplash.com/photo-1608222351212-18fe0ec7b13b?w=400&h=240&fit=crop&crop=center",
    slug: "sms-marketing-guide"
  },
  {
    id: 5,
    title: "Customer Retention Strategies That Actually Work in 2024",
    excerpt: "Proven tactics to keep customers coming back and spending more, without increasing your marketing budget.",
    category: "Customer Retention",
    readTime: "6 min read",
    date: "2024-03-05",
    image: "https://images.unsplash.com/photo-1730382624709-81e52dd294d4?w=400&h=240&fit=crop&crop=center",
    slug: "customer-retention-strategies"
  },
  {
    id: 6,
    title: "From Enquiry to Sale: Building a Winning Sales Pipeline",
    excerpt: "The step-by-step process successful local businesses use to convert more enquiries into paying customers.",
    category: "Sales",
    readTime: "8 min read",
    date: "2024-03-01",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=240&fit=crop&crop=center",
    slug: "sales-pipeline-guide"
  },
  {
    id: 7,
    title: "How to Reduce No-Shows by 80%: The Ultimate Guide for Local Businesses",
    excerpt: "No-shows costing you thousands? Discover the proven strategies that successful businesses use to dramatically reduce missed appointments.",
    category: "Operations",
    readTime: "5 min read",
    date: "2024-02-28",
    image: "https://images.unsplash.com/photo-1506784983877-45594efa4cbe?w=400&h=240&fit=crop&crop=center",
    slug: "reduce-no-shows-guide"
  },
  {
    id: 8,
    title: "10 Local SEO Mistakes That Are Costing You Customers",
    excerpt: "Is your business invisible on Google? These common local SEO mistakes could be why customers are finding your competitors instead of you.",
    category: "SEO",
    readTime: "7 min read",
    date: "2024-02-25",
    image: "https://images.unsplash.com/photo-1432888622747-4eb9a8f2c293?w=400&h=240&fit=crop&crop=center",
    slug: "local-seo-mistakes"
  },
  {
    id: 9,
    title: "The Power of Email Marketing for Service-Based Businesses",
    excerpt: "Email isn't dead - it's one of the most powerful tools for local businesses. Learn how to use it to increase repeat business by 45%.",
    category: "Email Marketing",
    readTime: "6 min read",
    date: "2024-02-22",
    image: "https://images.unsplash.com/photo-1557200134-90327ee9fafa?w=400&h=240&fit=crop&crop=center",
    slug: "email-marketing-service-businesses"
  },
  {
    id: 10,
    title: "Social Media Strategy for Local Businesses: What Actually Works",
    excerpt: "Stop wasting time on social media. This data-driven guide shows you exactly where to focus your efforts for maximum ROI.",
    category: "Social Media",
    readTime: "8 min read",
    date: "2024-02-20",
    image: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=400&h=240&fit=crop&crop=center",
    slug: "social-media-strategy-local-business"
  },
  {
    id: 11,
    title: "Why You're Losing 73% of Your Leads (And How to Fix It Today)",
    excerpt: "Most local businesses lose 3 out of 4 leads before they even get a chance to convert them. Here's why it happens and the simple fix.",
    category: "Lead Generation",
    readTime: "5 min read",
    date: "2024-02-18",
    image: "https://images.unsplash.com/photo-1551836022-deb4988cc6c0?w=400&h=240&fit=crop&crop=center",
    slug: "stop-losing-leads"
  },
  {
    id: 12,
    title: "The Complete Guide to Automating Your Local Business",
    excerpt: "From lead capture to customer retention - a comprehensive roadmap to automate your business and reclaim your time.",
    category: "Automation",
    readTime: "10 min read",
    date: "2024-02-15",
    image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=400&h=240&fit=crop&crop=center",
    slug: "complete-automation-guide"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What happens after my 14-day trial?",
    answer: "After your trial ends, you can choose to continue with any of our monthly plans. If you don't upgrade, your account will be paused and your data safely stored for 30 days, giving you time to decide."
  },
  {
    id: 2,
    question: "Can I cancel anytime?",
    answer: "Absolutely! There are no long-term contracts. You can cancel your subscription at any time from your account settings, and you'll retain access until the end of your current billing period."
  },
  {
    id: 3,
    question: "Do you help with setup?",
    answer: "Yes! All Growth and Domination plans include setup assistance. Our team will help you get started, import your contacts, and set up your first automation sequences. We also provide training materials and ongoing support."
  },
  {
    id: 4,
    question: "Is this for my type of business?",
    answer: "Local Business Heroes works for virtually any local service business - from salons and gyms to tradies and consultants. If you serve customers in a specific geographic area, our system can help you grow."
  },
  {
    id: 5,
    question: "How quickly will I see results?",
    answer: "Most of our clients see an increase in lead capture within the first week. Automated follow-up starts working immediately, and you'll typically see improved conversion rates within 30 days of proper setup."
  },
  {
    id: 6,
    question: "What if I need help or have questions?",
    answer: "We provide comprehensive support including email support for all plans, phone support for Growth and Domination plans, plus a detailed knowledge base, video tutorials, and live training sessions."
  }
];

export const painPoints = [
  {
    id: 1,
    title: "Missing Leads While You Sleep",
    description: "Potential customers are contacting you outside business hours, but by the time you respond, they've already chosen a competitor."
  },
  {
    id: 2,
    title: "Drowning in Admin Tasks",
    description: "You're spending more time on paperwork, follow-ups, and scheduling than actually serving customers or growing your business."
  },
  {
    id: 3,
    title: "Inconsistent Follow-Up",
    description: "You know follow-up is crucial, but between serving customers and running the business, leads slip through the cracks."
  },
  {
    id: 4,
    title: "No-Shows Killing Profits",
    description: "Customers book appointments then don't show up, leaving gaps in your schedule and money on the table."
  },
  {
    id: 5,
    title: "Struggling to Get Reviews",
    description: "Happy customers don't leave reviews, but unhappy ones do. Your online reputation isn't reflecting the quality of your work."
  }
];

export const stats = [
  { number: "40%", label: "Average increase in leads" },
  { number: "60%", label: "Reduction in admin time" },
  { number: "300%", label: "More Google reviews" },
  { number: "24/7", label: "Automated lead capture" }
];